require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./solutions-customer-relationship.json") })
        }
      }, "path---solutions-customer-relationship");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---solutions-customer-relationship!./.cache/json/solutions-customer-relationship.json
// module id = 1493
// module chunks = 231608221292675